import React, { useState } from 'react';

function ThroughputChartHeader({ onExport }) {
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const handleExportClick = () => {
    setShowConfirmModal(true);
  };

  const confirmExport = () => {
    setShowConfirmModal(false);
    onExport();
  };

  const cancelExport = () => {
    setShowConfirmModal(false);
  };

  return (
    <>
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-bold text-gray-700">Throughput por tipo de item</h2>
        
        {/* Botão de exportar */}
        <div className="flex bg-gray-100 rounded-lg p-1">
          <button
            onClick={handleExportClick}
            className="px-4 py-2 rounded-md text-sm font-medium transition-colors text-gray-600 hover:text-gray-900 hover:bg-gray-50"
            title="Exportar gráfico como imagem"
          >
            <span className="mr-2">📸</span>
            Exportar
          </button>
        </div>
      </div>

      {/* Modal de confirmação */}
      {showConfirmModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-xl p-6 mx-4 max-w-md w-full">
            <div className="flex items-center mb-4">
              <span className="text-2xl mr-3">📸</span>
              <h3 className="text-lg font-semibold text-gray-900">Exportar Gráfico</h3>
            </div>
            
            <p className="text-gray-600 mb-6">
              Deseja fazer o download do gráfico de Throughput como imagem PNG?
            </p>
            
            <div className="flex justify-end gap-3">
              <button
                onClick={cancelExport}
                className="px-4 py-2 text-gray-600 hover:text-gray-800 font-medium transition-colors"
              >
                Cancelar
              </button>
              <button
                onClick={confirmExport}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 font-medium transition-colors"
              >
                Fazer Download
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ThroughputChartHeader;
